import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import { ThemeProvider } from "../../Contexts/ThemeContext";
import { UserProvider } from "../../Contexts/user/UserContext";

import "../../core/core.css";
import "../page.css";
import "./AdminMain.css";
// Register all Community features
ModuleRegistry.registerModules([AllCommunityModule]);
export const AdminBasePage = ({ children }: { children: React.ReactNode }) => {
  return (
    <UserProvider>
      <ThemeProvider>{children}</ThemeProvider>
    </UserProvider>
  );
};
